import React, { Component } from 'react';
import NewsConfiguration from '../../../../src/models/NewsConfiguration';
import NewsArticle from '../../../../src/models/NewsArticle';
import Modal from 'react-bootstrap/esm/Modal';
import Cookies from 'universal-cookie';

type NewsModalDesktopPageProps = {
  configuration: NewsConfiguration,
  articles: NewsArticle[]
}

type NewsModalDesktopPageState = {
  showModal: boolean,
  articleTabRefs: any[],
  articlePanelRefs: any[],
  activeTab: number,
}

export default class NewsModalDesktopPage extends Component<NewsModalDesktopPageProps, NewsModalDesktopPageState> {


  constructor(props: NewsModalDesktopPageProps) {
    super(props);
    this.state = {
      showModal: true,
      articleTabRefs: [],
      articlePanelRefs: [],
      activeTab: 0,
    };
    this.setTabRef = this.setTabRef.bind(this);
    this.setPanelRef = this.setPanelRef.bind(this);
  }

  public setTabRef(ref: any) {
    this.state.articleTabRefs.push(ref);
  }

  public setPanelRef(ref: any) {
    this.state.articlePanelRefs.push(ref);
  }

  public setActiveTab(tab: number) {
    for (let i = 0; i < this.state.articleTabRefs.length; i++) {
      this.state.articleTabRefs[i].classList.remove(...["active", "show"]);
      this.state.articlePanelRefs[i].classList.remove(...["active", "show"]);
    }
    this.state.articleTabRefs[tab].classList.add(...["active", "show"]);
    this.state.articlePanelRefs[tab].classList.add(...["active", "show"]);
    const state = this.state;
    this.setState({
      showModal: state.showModal,
      articleTabRefs: state.articleTabRefs,
      articlePanelRefs: state.articlePanelRefs,
      activeTab: tab,
    })
  }

  public closeModal() {
    const cookies = new Cookies();
    let seenNews = cookies.get('seenNewsModal') ?? [];
    seenNews = [
      ...seenNews,
      ...this.props.configuration.articles.map(a => a.nodeGUID)
    ];

    cookies.set('seenNewsModal', seenNews, { path: '/', maxAge: 31556926, secure: true });
    this.setState({
      showModal: false,
    })
  }

  public render() {
    return (
      <>
        <Modal
          show={this.state.showModal}
          onHide={() => this.closeModal()}
          keyboard={false}
          backdrop="static"
          dialogClassName="important-news-modal-desktop"
          size="lg"
        >
          <Modal.Body bsPrefix="modal-body p-0 mh-100">
            <div className="d-flex flex-column h-100">

              <div className="nav nav-tabs d-flex flex-row pt-3 px-3 border-0" role="tablist">
                {
                  this.props.articles.map((article: NewsArticle, index: number) => {
                    return (
                      <a key={"tab-" + index} onClick={() => this.setActiveTab(index)} ref={this.setTabRef} id={"tab-" + index} href={"#panel-" + index} className={"nav-link flex-grow-1 w-50 border-0 btn text-left p-3" + (index === 0 ? " active" : "")} role="tab" data-toggle="tab" aria-controls={"panel-" + index} aria-selected={index === 0}>
                        <p className="text-overline small text-red font-weight-bolder my-1">{this.props.configuration.importantUpdateText} {article.publicationDate}</p>
                        <p className="font-weight-bold mb-0 text-line-height-small">{article.title}</p>
                      </a>
                    )
                  })
                }
              </div>
              <div className="tab-content flex-grow-1 bg-ecru px-6">
                {
                  this.props.articles.map((article: NewsArticle, index: number) => {
                    return (
                      <div key={"panel-" + index} ref={this.setPanelRef} className={"tab-pane fade" + (index === 0 ? " show active" : "")} id={"panel-" + index} role="tabpanel" aria-labelledby={"tab-" + index}>
                        <div className="px-1 py-5" dangerouslySetInnerHTML={{ __html: article.html }} >
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {
              (this.props.articles.length === 1) &&
              <>
                <button type="button" className={"btn btn-primary"} onClick={() => { this.closeModal(); }}>{this.props.configuration.continueToSiteText}</button>
              </>
            }
            {
              this.state.activeTab !== 0 &&
              this.props.articles.length > 1 &&
              <>
                <button type="button" className="btn btn-outline-primary" onClick={() => this.setActiveTab(this.state.activeTab - 1)}>
                  {this.props.configuration.previousUpdateText}
                </button>
                <button type="button" className={"btn btn-primary"} onClick={() => { this.closeModal(); }}>{this.props.configuration.continueToSiteText}</button>
              </>
            }
            {
              this.state.activeTab + 1 < this.props.articles.length &&
              <>
                <button type="button" className={"btn btn-outline-primary"} onClick={() => { this.closeModal(); }}>{this.props.configuration.continueToSiteText}</button>
                <button type="button" className="btn btn-primary" onClick={() => { this.setActiveTab(this.state.activeTab + 1) }}>
                  {this.props.configuration.nextUpdateText}
                </button>
              </>
            }
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}